export default __webpack_public_path__ + "ed132829db19178c07dd20159fee371e.gif";